import "./PrivacyPolicy.css";

//This privacy policy may be reused only for static, promotional AR or web experiences that do not collect personal data,
// do not use analytics, do not enable face or voice tracking, and rely solely on third-party platforms (such as Snap Camera Kit)
//  for any required camera functionality; it must not be reused for any experience that captures user information, uses tracking
// or analytics, enables biometric features, or introduces interactive, account-based, or lead-generating functionality.

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <h1>Privacy Policy</h1>
      <h2> Last updated: February 2, 2026</h2>
      <p>Paradowski Creative respects your privacy.</p>

      <p>
        {" "}
        This website hosts an augmented reality (AR) experience using Snap
        Inc.’s Camera Kit technology. The experience is accessed via a QR code
        and runs directly in your web browser.
      </p>

      <h3 className="header-privacy"> Information We Do Not Collect</h3>
      <p>
        {" "}
        Paradowski Creative does not collect, store, or process personal
        information through this AR experience. We do not require account
        creation, logins, or form submissions.
      </p>

      <p> We do not collect:</p>
      <ul>
        <li> Names, email addresses, or contact information</li>
        <li> Device identifiers or persistent user identifiers</li>
        <li>Face data or biometric identifiers</li>
        <li> Audio recordings</li>
        <li> Location data</li>
      </ul>

      <h3 className="header-privacy"> Camera and AR Functionality</h3>
      <p>
        {" "}
        This experience uses camera access solely to enable image-based tracking
        required for the AR feature. The camera is used to recognize a printed
        image and display a 3D visual overlay.
      </p>
      <ul>
        <li>No face tracking is used</li>
        <li> No facial recognition is performed</li>
        <li>
          {" "}
          Camera data is not stored or transmitted by Paradowski Creative
        </li>
      </ul>

      <h3>Snap Camera Kit</h3>
      <p>
        {" "}
        The AR functionality is powered by Snap Inc.’s Camera Kit. Snap may
        process certain data as described in its own privacy documentation.
      </p>
      <p> Use of the AR experience is subject to Snap’s:</p>
      <ul>
        <li>
          {" "}
          <a href="https://values.snap.com/privacy/privacy-policy">
            Privacy Policy
          </a>
        </li>
        <li>
          {" "}
          <a href="https://www.snap.com/terms"> Terms of Service </a>{" "}
        </li>
      </ul>

      <p>
        {" "}
        You are required to review and accept Snap’s terms before the camera
        experience begins.
      </p>

      <p>
        {" "}
        Paradowski Creative does not control how Snap processes data and is not
        responsible for Snap’s data practices.
      </p>

      <h3 className="header-privacy"> Analytics and Tracking</h3>
      <p>
        {" "}
        This website does not use Google Analytics or other third-party
        analytics tools. We do not track individual users or user behavior.
      </p>

      <h3 className="header-privacy"> Cookies</h3>
      <p>
        {" "}
        We do not set cookies for tracking or advertising purposes. Any cookies
        used are strictly required for basic site functionality or are set by
        third-party technology providers such as Snap.
      </p>

      <h3 className="header-privacy"> Data Sharing</h3>
      <p>
        {" "}
        Paradowski Creative does not sell, share, or disclose personal data.
      </p>

      <h3 className="header-privacy"> Changes to This Policy</h3>
      <p>
        {" "}
        This Privacy Policy may be updated if the functionality of the
        experience changes. Any updates will be reflected by a revised “Last
        updated” date.
      </p>

      <h3 className="header-privacy"> Contact</h3>
      <p>
        If you have questions about this Privacy Policy, please contact:{" "}
        <a href="mailto:info@paradowski.com">info@paradowski.com</a>
      </p>
    </div>
  );
}

export default PrivacyPolicy;
